import { useState } from "react";
import { useNavigate } from "react-router";

import API_Calls_Membership_DataFile from "@/api/calls/API_Calls_DataFile";
import API_Calls_DataFile from "@/api/calls/political/API_Calls_DataFile";
import API_Calls_Events from "@/api/calls/political/API_Calls_Events";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

export const useFileSelectorHook = (
  user,
  dataSource,
  event,
  selectedFile,
  setNotification
) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const { uploadFile } = API_Calls_DataFile();
  const { getUploadColumns } = API_Calls_Membership_DataFile();
  const { getEvents } = API_Calls_Events();

  const { handlePoliticalDataChange } = useUpdateDataContext();
  const navigate = useNavigate();

  const uploadSelectedFile = async () => {
    setLoading(true);
    const data = {
      file: selectedFile,
    };
    const response = await uploadFile(
      user.org_name,
      event.event_id,
      dataSource,
      data
    );
    if (!response.error && response.data) {
      return response;
    } else {
      setNotification({
        title: response.message || "There was a problem uploading this file",
        message: response.details,
        severity: "error",
        messageDuration: 3000,
      });
    }
    setLoading(false);
    return false;
  };

  const handleContinue = async () => {
    const uploadResponse = await uploadSelectedFile();
    setLoading(false);
    if (uploadResponse) {
      setIsProcessing(true);
      const res = await getUploadColumns(
        user.org_name,
        parseFilename(uploadResponse.data.filename).name,
        parseFilename(uploadResponse.data.filename).created,
        dataSource
      );
      if (!res.error && res.data) {
        handlePoliticalDataChange({
          dataSource,
          eventName:
            event.eventName ||
            `${selectedFile.name} - ${parseFilename(uploadResponse.data.filename).created}`,
          eventDate: event.eventDate,
          columns: res.data,
          fileName: selectedFile.name,
          fileCreated: parseFilename(uploadResponse.data.filename).created,
          affiliate: user.org_name,
        });
        navigate("/political/update-data/map-template");
      } else {
        setIsProcessing(false);
        console.error("Unable to fetch column headers: ", res);
        setNotification({
          message: "Unable to process at this time.",
          severity: "error",
          duration: 5000,
        });
      }
    }
  };

  const fetchEvents = async (affiliate, active_only) => {
    const res = await getEvents(affiliate, active_only);
    if (!res.error && res.data) {
      return res.data;
    } else {
      console.error(res);
      setNotification({
        title: res.message || "Unable to fetch events at this time",
        message: res.details,
        severity: "error",
        messageDuration: 7000,
      });
      return false;
    }
  };

  const parseFilename = (filename) => {
    if (filename) {
      const parts = filename.split("/");
      return { name: parts.at(4), created: parts.at(3) };
    } else {
      return null;
    }
  };

  return { handleContinue, isProcessing, loading, fetchEvents };
};
